import { z } from "zod";
import { GroupJoinRequestStatus } from "../enum-group.js";

export const listGroupJoinRequestsQuerySchema = z
	.object({
		status: z.enum(GroupJoinRequestStatus).optional(),
		group_id: z.uuid().optional(),
	})
	.strict();

export type ListGroupJoinRequestsQuery = z.infer<typeof listGroupJoinRequestsQuerySchema>;
